import React from "react";
import { useTranslation } from "react-i18next";
import { Pagination as MantinePagination } from "@mantine/core";
import styled from "styled-components";
import Icon from "./Icon";
const CONTROL_ARIA_LABELS = {
  first: "pagination.first",
  previous: "pagination.previous",
  next: "pagination.next",
  last: "pagination.last"
};
export var ICON_NAMES = /* @__PURE__ */ ((ICON_NAMES2) => {
  ICON_NAMES2["FIRST"] = "keyboard_double_arrow_left";
  ICON_NAMES2["PREVIOUS"] = "chevron_left";
  ICON_NAMES2["NEXT"] = "chevron_right";
  ICON_NAMES2["LAST"] = "keyboard_double_arrow_right";
  return ICON_NAMES2;
})(ICON_NAMES || {});
const PrevIcon = () => /* @__PURE__ */ React.createElement(Icon, { name: "chevron_left" /* PREVIOUS */ });
const NextIcon = () => /* @__PURE__ */ React.createElement(Icon, { name: "chevron_right" /* NEXT */ });
const FirstIcon = () => /* @__PURE__ */ React.createElement(Icon, { name: "keyboard_double_arrow_left" /* FIRST */ });
const LastIcon = () => /* @__PURE__ */ React.createElement(Icon, { name: "keyboard_double_arrow_right" /* LAST */ });
const StyledPagination = styled(MantinePagination)`
  margin-top: 10px;
  overflow: hidden;
  padding-bottom: 2px;

  .mantine-Group-root {
    gap: 0;
    justify-content: center;
  }

  .mantine-Pagination-control {
    border-color: ${({ theme }) => theme.colors.input.border};

    &:not([data-active]) {
      background-color: transparent;
    }

    & + .mantine-Pagination-control {
      border-left: none;
    }
  }
`;
const Pagination = ({
  currentPage,
  totalPages,
  boundaryPagesRange = 1,
  siblingPagesRange = 1,
  hidePreviousAndNextPageLinks = false,
  hideFirstAndLastPageLinks = false,
  disabled = false,
  onChange = () => {
  },
  warnIfPageOutOfBounds = true
}) => {
  const { t } = useTranslation("common");
  if (totalPages <= 1) {
    return null;
  }
  if (currentPage > totalPages) {
    if (warnIfPageOutOfBounds) {
      console.warn("Pagination: `currentPage` prop should not be larger than `totalPages` prop.");
    }
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    StyledPagination,
    {
      value: currentPage,
      total: totalPages,
      boundaries: boundaryPagesRange,
      siblings: siblingPagesRange,
      withControls: !hidePreviousAndNextPageLinks,
      withEdges: !hideFirstAndLastPageLinks,
      disabled,
      onChange,
      previousIcon: PrevIcon,
      nextIcon: NextIcon,
      firstIcon: FirstIcon,
      lastIcon: LastIcon,
      getControlProps: (control) => ({ "aria-label": t(CONTROL_ARIA_LABELS[control]) }),
      getItemProps: (page) => ({
        "aria-label": t("pagination.page", { page }),
        ...page === currentPage ? { title: t("pagination.active_page") } : {}
      }),
      "data-testid": "graylog-pagination"
    }
  );
};
export default Pagination;
